import { render, staticRenderFns } from "./HireLetter.vue?vue&type=template&id=6af3fd54"
import script from "./HireLetter.vue?vue&type=script&lang=js"
export * from "./HireLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af3fd54')) {
      api.createRecord('6af3fd54', component.options)
    } else {
      api.reload('6af3fd54', component.options)
    }
    module.hot.accept("./HireLetter.vue?vue&type=template&id=6af3fd54", function () {
      api.rerender('6af3fd54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/HireLetter.vue"
export default component.exports